define.alias("shared/components/shared/table-analytics", "settings/components/shared/table-analytics");